import { HelpCircle } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

export const Comfort = () => (
  <section data-testid="comfort-section" className="py-24 md:py-36 bg-sand/50 border-y border-champagne/40">
    <div className="max-w-7xl mx-auto px-5 md:px-10 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
      <div>
        <SectionHead
          index="06"
          eyebrow="Comfort & Technology"
          title="Advanced Technology. Designed for Comfortable Treatment."
          copy="Modern laser systems are designed to make treatment significantly more comfortable than many people expect. You may experience warmth, snapping or mild discomfort during treatment, depending on individual sensitivity."
        />
        <Reveal delay={0.2}>
          <div data-testid="comfort-faq-card" className="mt-10 rounded-3xl border border-champagne bg-white p-8">
            <p className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-teal/70">
              <HelpCircle className="w-4 h-4" strokeWidth={1.6} />
              Will it hurt?
            </p>
            <p className="mt-4 font-display text-xl md:text-2xl font-light leading-snug text-ink">
              Most patients tolerate underarm laser treatment well, although sensation varies from person to person.
            </p>
          </div>
        </Reveal>
      </div>
      <Reveal delay={0.1}>
        <div className="relative overflow-hidden rounded-[2rem] border border-champagne/60 aspect-[4/3] shadow-[0_40px_80px_-40px_rgba(26,59,57,0.3)]">
          <img
            src="/media/clinic-room.jpeg"
            alt="Treatment room with advanced laser technology at Krystal Skin And Laser Clinic, Ameerpet"
            className="h-full w-full object-cover transition-transform duration-[1.6s] ease-out hover:scale-[1.04]"
            loading="lazy"
            data-testid="comfort-image"
          />
        </div>
      </Reveal>
    </div>
  </section>
);
